export const ideasWall = {
};